export const ideasWall = {
};